/*
  Pythal FAQ page: live question search (filters and highlights), topic index scroll spy, and
  opening the question named in the URL hash.
*/
(() => {
  const norm = (value) => value.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  const escapeRe = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const init = (root) => {
    if (root.dataset.pyFqReady) return;
    root.dataset.pyFqReady = 'true';

    const input = root.querySelector('[data-py-fq-search]');
    const clear = root.querySelector('[data-py-fq-clear]');
    const status = root.querySelector('[data-py-fq-status]');
    const empty = root.querySelector('[data-py-fq-empty]');
    const term = root.querySelector('[data-py-fq-term]');
    const groups = [...root.querySelectorAll('[data-py-fq-group]')];
    const items = [...root.querySelectorAll('[data-py-fq-item]')].map((el) => {
      const label = el.querySelector('.py-fq__q-text');
      return { el, label, text: label.textContent, haystack: norm(el.textContent) };
    });

    const highlight = (item, query) => {
      if (!query) { item.label.textContent = item.text; return; }
      const re = new RegExp(`(${query.split(' ').filter(Boolean).map(escapeRe).join('|')})`, 'gi');
      item.label.replaceChildren(...item.text.split(re).map((part, i) => {
        if (i % 2 === 0) return document.createTextNode(part);
        const mark = document.createElement('mark');
        mark.textContent = part;
        return mark;
      }));
    };

    const filter = () => {
      const raw = input.value;
      const query = norm(raw);
      const words = query.split(' ').filter(Boolean);
      let shown = 0;

      items.forEach((item) => {
        const match = words.every((w) => item.haystack.includes(w));
        item.el.hidden = !match;
        if (match) shown += 1;
        highlight(item, query && match ? raw.trim().replace(/\s+/g, ' ') : '');
      });
      groups.forEach((group) => { group.hidden = !group.querySelector('[data-py-fq-item]:not([hidden])'); });

      clear.hidden = !raw;
      empty.hidden = !query || shown > 0;
      term.textContent = raw.trim();
      const found = () => {
        const tpl = shown === 1 ? input.dataset.foundOne : input.dataset.foundOther;
        return tpl ? tpl.replace('[count]', shown) : `${shown} ${shown === 1 ? 'answer' : 'answers'} found`;
      };
      status.textContent = query ? (shown ? found() : '') : '';
    };

    if (input) {
      input.addEventListener('input', filter);
      root.querySelector('[data-py-fq-form]').addEventListener('submit', (event) => event.preventDefault());
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && input.value) { input.value = ''; filter(); }
      });
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    }

    // Topic index: mark the topic currently in view.
    const links = [...root.querySelectorAll('[data-py-fq-toc]')];
    if (links.length && 'IntersectionObserver' in window) {
      const byId = new Map(links.map((a) => [a.hash.slice(1), a]));
      const visible = new Set();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? visible.add(e.target.id) : visible.delete(e.target.id)));
        const current = groups.find((g) => visible.has(g.id));
        if (current) links.forEach((a) => a.classList.toggle('is-active', a === byId.get(current.id)));
      }, { rootMargin: '-120px 0px -55% 0px' });
      groups.filter((g) => byId.has(g.id)).forEach((g) => observer.observe(g));
    }

    // Open a question linked directly, e.g. /pages/faq#py-fq-q-<block id>.
    const openFromHash = () => {
      const target = location.hash && root.querySelector(`details#${CSS.escape(decodeURIComponent(location.hash.slice(1)))}`);
      if (target) { target.open = true; target.scrollIntoView({ block: 'center' }); }
    };
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  };

  const boot = () => document.querySelectorAll('[data-py-fq]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
